export default __webpack_public_path__ + "static/media/PAFI_Announcement of GMS 2024.cdf130e6.pdf";